class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.bindOverlayClose();
    this.setHeaderCartIconAccessibility();
  }

  // Fix 2026-09-28: el overlay puede no existir si el repintado de la seccion
  // devuelve markup incompleto; sin guarda esto lanzaba
  // "cannot read properties of null (reading 'addEventListener')" al agregar al carro.
  bindOverlayClose() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      if (parsedState.sections)
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.bindOverlayClose();
      this.open();
    });

    // El contador del encabezado se pinta con Liquid en sections/header.liquid y NO viaja
    // en las secciones que repinta este cajon, asi que tras un agregado por AJAX se quedaba
    // en su valor viejo ("Bag 0" con el carrito lleno). Se refresca a mano. 2026-08-27.
    this.qRefrescarContador(parsedState);
  }

  qRefrescarContador(parsedState) {
    const pintar = (n) => {
      document.querySelectorAll('.cart-count, .cart-count-bubble span[aria-hidden]').forEach((el) => {
        el.textContent = n;
      });
    };
    if (parsedState && typeof parsedState.item_count === 'number') {
      pintar(parsedState.item_count);
      return;
    }
    fetch(`${routes.cart_url}.js`)
      .then((r) => r.json())
      .then((cart) => pintar(cart.item_count))
      .catch(() => {});
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/*
  El boton "Bag" del encabezado (sections/header.liquid) es un <a href="/cart"> sin manejador,
  asi que tocarlo cargaba la pagina completa del carrito en vez de abrir el cajon.
  Aqui se intercepta el clic y se abre el cajon. Se conserva el href como respaldo:
  si el JS no carga, el enlace sigue llevando a /cart y nadie se queda sin carrito.
  Anadido 2026-08-27.
*/
(function qAbrirDesdeElBoton() {
  function enlazar() {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon || typeof cajon.open !== 'function') return;
    document.querySelectorAll('.nav-cart-btn, a[href$="/cart"].cart-icon-bubble').forEach(function (a) {
      if (a.dataset.qDrawerBound === '1') return;
      a.dataset.qDrawerBound = '1';
      a.setAttribute('role', 'button');
      a.setAttribute('aria-haspopup', 'dialog');
      a.addEventListener('click', function (ev) {
        // respeta abrir en pestana nueva y el clic del medio
        if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;
        ev.preventDefault();
        cajon.open(a);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enlazar);
  } else {
    enlazar();
  }
})();
